/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const StatisticsIcon = createIcon(
  '0 0 20 20',
  <path d="M18 18H2.085v-2H18zm-1.407-7.929-2.11-2.122-4.512 4.536L7.11 9.607 3.407 13.33 2 11.914 7.109 6.78 9.97 9.657l3.105-3.122-2.11-2.12L18 3z" />,
);
